<template>
  <div v-if="!isAppOnly" class="item-menu" v-bind:class="classCols" data-toggle="tooltip" v-bind:title="item.description"
       @click.stop="isHalf ? show(true) : show()" >
    <div class="inner" v-bind:class="{'hight-line-item' : is_hight_line}">
      <!--<div class="">-->
        <button class="badge badge--xs badge--primary badge--top-right" v-if="isPizzaItem(item)"
              @click.stop="show()">{{ $t('btn_customise') }}</button>
        <div v-show="item.customize" class="ribbona">
          <span>{{item.customize ? item.customize.tag : ''}}</span>
        </div>
        <div class="menu-image  bg1 ">
          <LazyImage v-if="item.image"
                    :alt="item.name"
                     :src="item.image.desktop_thumbnail" />
        </div>
        <div class="menu-name text-bold" style="z-index: 1">{{ item.name }}
          <img :alt="item.name" v-bind:src="img.image.icon" v-for="(img, indexI) in item.menu_attributes" :key="indexI" width="25" class="pl-5" />
        </div>

      <div v-if="item.marketing_description" class="menu-description  marketing_description" style="z-index: 1">
        <nl2br tag="div" v-if="item.marketing_description" :text="item.marketing_description"/>
      </div>
      <div v-if="item && item.first_layers && !isOneSideOneCrust(item)" class="menu-info-content">
        <label v-if="!isMobile()" class="menu-name">{{$t('select_size_desktop')}}</label>
        <label v-else-if="isMobile()" class="menu-name">{{$t('select_size_mobile')}}</label>

        <div class="select-size" @click.stop>
          <select v-model="selected_crust_size" class="hide-expand-arrow">
            <option v-for="(option,index) in crust_size" :value="option" :key="index+0">
              {{option.name}}
            </option>
          </select>
          <i class="icon-caret-down--black ml-auto absolute pin-r pin-t pin-b mt-5 mr-5"
             style="width: 20px; height: 20px; pointer-events: none;"></i>
        </div>
      </div>
      <div class="menu-price" style="z-index: 1;display: block;" v-if="!isHalf">
        <div class="btn btn-success btn-add-single-item text-left" style="width: 100%;" v-if="price(item)"
             v-on:click.stop="addToBasket">
          {{$t('button_add')}} <span
          class="pull-right">{{ $const.CURRENCY }} {{ formatNum(selected_crust_size.price) }}</span>
        </div>
        <div v-else class="btn btn-success btn-add-single-item text-left" style="width: 100%;"
             v-on:click.stop="addToBasket">
          {{$t('button_add')}} <span class="pull-right">{{ $const.CURRENCY }} {{ formatNum(item.price) }}</span>
        </div>
      </div>
    </div>
  </div>
  <a v-else class="item-menu item-app-only-deals" v-bind:class="classCols" target="_blank" :href="linkAppOnly" data-toggle="tooltip" v-bind:title="item.description">
    <div class="inner" v-bind:class="{'hight-line-item' : is_hight_line}" style="position: relative;">
      <div class="container-blur"></div>
      <div class="ribbona ribbona-app-only" style="z-index: 101;">
        <span>{{ $t('app_only')}} </span>
      </div>
      <div class="menu-image  bg1 ">
        <LazyImage v-if="item.image" :alt="item.name" :src="item.image.desktop_thumbnail" />
      </div>
      <div class="menu-name text-bold" style="z-index: 101">
        {{ item.name }}
        <img :alt="item.name" v-bind:src="img.image.icon" v-for="(img, indexI) in item.menu_attributes" :key="indexI" width="25" class="pl-5" />
      </div>
      <div v-if="item.marketing_description" class="menu-description  marketing_description" style="z-index: 101">
        <div v-html="nl2brMethod(item.marketing_description)" class="ellipsis-text" ></div>
      </div>
      <div class="text-center text-bold" style="z-index: 101;">
        <div v-if="price(item) && !isHalf" class="item-menu__price">
          {{ $const.CURRENCY }} {{ formatNum(selected_crust_size.price) }}
        </div>
        <div v-else class="item-menu__price">
          {{ $const.CURRENCY }} {{ formatNum(item.price) }}
        </div>
      </div>
      <div v-if="item && item.first_layers && !isOneSideOneCrust(item)" class="menu-info-content">
        <label v-if="!isMobile()" class="menu-name">{{$t('select_size_desktop')}}</label>
        <label v-else-if="isMobile()" class="menu-name">{{$t('select_size_mobile')}}</label>
        <div class="select-size" @click.stop>
          <select v-model="selected_crust_size" class="hide-expand-arrow">
            <option v-for="(option,index) in crust_size" :value="option" :key="index+0">
              {{option.name}}
            </option>
          </select>
          <i class="icon-caret-down--black ml-auto absolute pin-r pin-t pin-b mt-5 mr-5"
             style="width: 20px; height: 20px; pointer-events: none;"></i>
        </div>
      </div>
      <div class="menu-price" style="z-index: 101; display: block;">
        <!-- pizza and rest -->
        <div class="btn btn-danger btn-add-single-item" style="width: 100%;" >
          <span class="addTextButton">{{$t('get_the_app_now')}}</span>
        </div>
      </div>
    </div>
  </a>
</template>
<script>
  import ModalUpSell from '../popup/ModalPizzaUpSell.vue'
  import * as action from '../../store/actions'
  import Ellipsis from '@/components/partials/Ellipsis'
  import DispositionPopup from '../home/HomeLocalizationMapGoogleApiNewDesign'
  import {
      mapGetters,
      mapActions
  } from 'vuex'


  export default {
    components: {
      Ellipsis,
      LazyImage: () => import('@/components/partials/LazyImage.vue'),
      DispositionPopup
    },
    props: ['item', 'cols', 'uuid', 'onlyLunch' ,'is_hight_line' , 'isHalf'],
    computed: {
      ...mapGetters({
        selectedCategory: 'selectedCategory',
        selectedSubCategory: 'selectedSubCategory',
      })

    },
    watch: {
      selected_crust_size (newVal, oldVal) {
        if (oldVal && oldVal.puuid != '') {
          this.chooseVariant(newVal.first, newVal.second)
        }
      }
    },
    mounted() {
      var vm = this
      if (this.uuid && ((this.uuid === this.item.uuid) || (this.uuid === this.item.friendly_seo_name))) {
        if (!this.checkPosition(this)) {
          this.$modal.show(DispositionPopup,{isPopup : true})
        }
      }

      vm.getCrustSize(this.item)
      this.isAppOnly = this.getValueFromAttr(this.item, 'customize.promote_for_download_app', false)
      this.linkAppOnly = this.getValueFromAttr(this.item, 'customize.deep_link_download_app', '')
    },
    data() {
      return {
        classCols: 'cols-' + this.cols,
        crust_size: [],
        selected_crust_size: {value: 0, name: '', price: 0, puuid: '', cuuid: ''},
        isAppOnly: false,
        linkAppOnly: ''
      }
    },
    methods: {/**
       * Chosen first and second layer
       */
        ...mapActions({
            setWarningDisposition: action.SET_WARNING_DISPOSITION,
            setUuidForNameseoDuplicate: action.SET_UUID_FOR_NAMESEO_DUPLICATE
        }),

      generatePrice(item, hasSize = true) {
        return this.$t('format_currency', {
          prefix: hasSize ? this.$t('from') : '',
          currency: this.$const.CURRENCY,
          amount: this.formatNumDisplay(item.min_price),
          start: '<span class="t13"><span class="font-08em cl-78838c fw-normal">', end: '</span></span>'
        })
      },

      chooseVariant (first, second) {
        let product = this.lodash.cloneDeep(this.item)
        let choosedFirst = this.lodash.cloneDeep(first)
        let choosedSecond = this.lodash.cloneDeep(second)
        product.first_layers = []
        product.first_layers.push(choosedFirst)
        if (first != null && !this.empty(first)) {
          product.first_layers[0].second_layers = [choosedSecond]
        }
        product.price = this.selected_crust_size.price
        let productclickUUid = product.uuid
        let variantUUid = ''
        if (!this.empty(first) && first.uuid != '') {
          variantUUid = first.uuid
        }
        if (!this.empty(second) && second.uuid != '') {
          variantUUid += '-' + second.uuid
        }
        this.evenTrackingProductClick(this, {uuid: productclickUUid, variant_uuid: variantUUid}, 'product-selection-from-variant-list-main-pizza-list')
      },
      getCrustSize(item) {
        if (item && item.first_layers) {
          for (let p in item.first_layers) {
            let parent = item.first_layers[p]
            if(parent.second_layers.length >0){
              for (let c in parent.second_layers) {
                if (c) {
                  let chil = parent.second_layers[c]
                  let temp = {
                    value: chil.id,
                    name: parent.name + ' ' + chil.name,
                    price: parent.price + chil.price,
                    puuid: parent.uuid,
                    first: parent,
                    second: chil,
                    cuuid: chil.uuid,
                    display_price : parent.display_price +  chil.display_price
                  }
                  this.crust_size.push(temp)
                }
              }
            }else{
              let temp = {
                value: parent.id,
                name: parent.name,
                price: parent.price,
                puuid: parent.uuid,
                first: parent,
                second: [],
                cuuid: '',
                display_price : parent.display_price
              }
              this.crust_size.push(temp)
            }
          }
          if (this.crust_size.length > 0) {
            this.selected_crust_size = this.crust_size[0]
          }
        }
      },
      borderTop(item) {
        if (item && item.first_layers && item.first_layers !== undefined) {
          return item.first_layers.length >=1 && item.first_layers[0].second_layers.length >= 1
        }
        return false
      },
      price(item) {
        return item && item.first_layers && item.first_layers.length >= 1
      },
      /**
       * adding item to cart
       * */
      addToBasket() {
        if (!this.checkPosition(this)) {
          this.setWarningDisposition(true)
          this.$modal.show(DispositionPopup,{isPopup : true})
        } else {
            this.setWarningDisposition(false)

          let pro = {
            id: this.item.uuid,
            uuid: this.item.uuid,
            name: this.item.name,
            price: 0,
            quantity: 1,
            item: this.item,
            first: {},
            second: {}
          }
          let firstSelected = this.selected_crust_size ? this.selected_crust_size.first : {}
          let secondSelected = this.selected_crust_size ? this.selected_crust_size.second : {}
          let price = 0

          //add to cart
          let item = {
            'group': {},
            'selling_start': this.item.selling_start,
            'products': []
          }
          item.group['outlet_code'] = this.getOutletCode(this)
          item.group['tier'] = this.$cart.tier
          item.group['order_type'] = this.$disposition.getByKey(this, 'orderType', 'D').charAt(0)
          item.group['order_time'] = this.getTimePickerDate(this)
          item.group['product_type'] = this.item.product_type
          item.group['combo_id'] = null
          item.group['quantity'] = 1
          item.price = price
          item.item = this.lodash.cloneDeep(this.item)
          item.first = firstSelected
          item.second = secondSelected
          let product = {}
          product.category_id = this.$cart.category_id
          product.combo_group_id = null
          product.product_id = this.item.uuid
          product.first_id = this.selected_crust_size ? this.selected_crust_size.puuid : null
          product.second_id = this.selected_crust_size ? this.selected_crust_size.cuuid : null
          product.toppings = {}
          product.toppings.remove = []
          product.toppings.extra = []
          item.products.push(product)


            //add to cart
          let upSell = []
          let trackingItem = this.lodash.cloneDeep(this.item)
          trackingItem.first_layers = []
            if (this.item.first_layers && this.item.first_layers.length > 0) {
              for (let f of this.item.first_layers) {
                if (f.uuid == this.selected_crust_size.puuid) {
                  trackingItem.first_layers.push(this.lodash.cloneDeep(f))
                  if (trackingItem.first_layers.length > 0) {
                    trackingItem.first_layers[0].second_layers = []
                  }
                  for (let s of f.second_layers) {
                    let price = parseFloat(f.price) + parseFloat(s.price)
                    if (price > this.selected_crust_size.price && s.second_id != this.$const.IGNORGE_CRUST_ID) {
                      let crustUpSell = {}
                      let itemUpSell = {
                        'group': {},
                        'selling_start': this.item.selling_start,
                        'products': []
                      }
                      itemUpSell.group['outlet_code'] = this.getOutletCode(this)
                      itemUpSell.group['tier'] = this.$cart.tier
                      itemUpSell.group['order_type'] = this.$disposition.getByKey(this, 'orderType', 'D').charAt(0)
                      itemUpSell.group['order_time'] = this.getTimePickerDate(this)
                      itemUpSell.group['product_type'] = this.item.product_type
                      itemUpSell.group['combo_id'] = null
                      itemUpSell.group['quantity'] = 1
                      crustUpSell.category_id = this.$cart.category_id
                      crustUpSell.combo_group_id = null
                      crustUpSell.product_id = this.item.uuid
                      crustUpSell.first_id = f.uuid
                      crustUpSell.second_id = s.uuid
                      crustUpSell.toppings = {}
                      crustUpSell.toppings.remove = []
                      crustUpSell.toppings.extra = []
                      itemUpSell.products.push(crustUpSell)
                      itemUpSell.name = s.name
                      itemUpSell.price = price
                      itemUpSell.showPrice = price - this.selected_crust_size.price
                      itemUpSell.item = this.lodash.cloneDeep(this.item)
                      itemUpSell.first = f
                      itemUpSell.second = s
                      upSell.push(itemUpSell)
                      if (trackingItem.first_layers.length > 0) {
                        trackingItem.first_layers[0].second_layers.push(this.lodash.cloneDeep(s))
                      }
                    }
                  }
                }
              }
            }
          let productclickUUid = pro.uuid
          let variantUUid = ''
          if (!this.empty(firstSelected) && firstSelected.uuid != '') {
            variantUUid = firstSelected.uuid
          }
          if (!this.empty(secondSelected) && secondSelected.uuid != '') {
            variantUUid += '-' + secondSelected.uuid
          }
          this.evenTrackingProductClick(this, {uuid: productclickUUid, variant_uuid: variantUUid}, 'direct-product-selection')
          pro.price = price
          pro.first = firstSelected
          pro.second = secondSelected
          pro.first_layers = []
          this.smartechAddItem(this, pro,this.$router)
          if (firstSelected != null && !this.empty(firstSelected)) {
            pro.first_layers.push(firstSelected)
            if (secondSelected != null && !this.empty(secondSelected)) {
              pro.first_layers[0].second_layers = [secondSelected]
            }
          }

          if (upSell.length > 0 && this.selected_crust_size.name.indexOf('San Francisco') == -1) {
              item.price = price
              //set number of show popup upsell
              let cachedData = this.getCacheLocalStorage(this.$const.KEY_UPSELL)
              let numOfClick = (cachedData.data != null) ? (cachedData.data.number + 1) : 1
              let infoPopup = {number : numOfClick}
              if(cachedData.expired || numOfClick <= this.$const.NUMBER_OF_SHOW_POPUP_UPSELL){
                if(cachedData.expired){
                  infoPopup = {number : 1}
                }
                this.setCacheLocalStorage(this.$const.KEY_UPSELL, infoPopup, 1 ,'days')
                // this.$modal.show(ModalUpSell, {
                //   items: upSell,
                //   previousItem: item,
                //   trackingItem: trackingItem,
                //   isDefault : upSell[0]
                // }, {
                //   class: 'modal-upsell',
                //   transition: 'nice-modal-fade',
                //   overlayTransition: 'overlay-fade',
                //   clickToClose: false,
                //   name: 'close-modal-upsell'
                // })
              }else{
                this.$cart.insert(this, item)
                this.eventTrackingAddToCart(this, pro, 'main', this.$const.CARD_ITEM_TYPE.SINGLE)
              }
            } else {
              this.$cart.insert(this, item)
              this.eventTrackingAddToCart(this, pro, 'main', this.$const.CARD_ITEM_TYPE.SINGLE)
            }

        }

      },
      addToCart(item) {},
      /**
       * Trigger before open modal popup
       * */
      beforeOpen(event) {
        document.body.classList.add('modal-open')
      },
      /**
       * Trigger before close modal popup
       * */
      beforeClose(event) {
        document.body.classList.remove('modal-open')
      },
      /**
       * Show modal popup
       * */
      show(isHalf = false) {
        let vm = this;
        if (vm.item.first_layers &&
        (vm.item.first_layers.length > 1 ||
        (vm.item.first_layers.length === 1 && vm.item.first_layers[0].second_layers && vm.item.first_layers[0].second_layers.length > 0))) {
          let nameSeo = vm.item.friendly_seo_name || vm.item.uuid
          this.setUuidForNameseoDuplicate(vm.item.uuid)
          if (nameSeo) {
            if (!this.checkPosition(this)) {
                this.$modal.show(DispositionPopup,{isPopup : true})
            } else {
              let slug = this.selectedCategory ? this.selectedCategory.slug : null;
              let slugSub = this.selectedSubCategory ? this.selectedSubCategory.slug : null
              if (isHalf) {
                let itemData = {uuid: vm.$const.HALF_HALF_UUID}

                if(this.onlyLunch){
                  itemData.uuid = vm.$const.HALF_HALF_LUNCH_UUID
                  vm.redirectToMenuPage(slug, vm.$const.HEADER_MENU.HALF_HAlF, vm.$const.HEADER_MENU.LUNCH_SET);
                }else{
                  vm.redirectToMenuPage(slug, vm.$const.HEADER_MENU.HALF_HAlF);
                }
                this.evenTrackingProductClick(this, itemData, 'direct-product-selection')

              } else {
                this.evenTrackingProductClick(this, this.item, 'direct-product-selection')
                // this.eventTrackingProductClickV2(this, this.item)
                vm.redirectToMenuPage(slug, slugSub, nameSeo)
              }
            }
          } else {
            vm.$notify({
              type: 'Error',
              title: vm.$t('missing_name_seo')
            })
          }
        }
      },
      convertSizeName(obj){
        if(this.selected_crust_size && obj &&(obj.name == this.selected_crust_size.name)){
            return this.subStringSizeName(obj.name)
        }else{
            return obj.name
        }
      },
      subStringSizeName(str) {
        let length = (window.innerWidth <= 768) ? 15 : 24
        if(str.length > length){
          return str.substring(0, length) + '...'
        }else{
          return str
        }
      }
    }
  }

</script>
<style scoped>
  select {
    box-shadow: none;
    font-size: 14px;
  }

  .icon-caret-down--black {
    position: absolute;
    width: 20px;
    height: 20px;
    pointer-events: none;
    background-image: url('../../assets/images/icons/icon-arrow-down.svg')
  }
  .text-bold {
    font-weight: 700;
  }
  /* CAUTION: IE hackery ahead */
  /*select::-ms-expand {*/
  /*display: none; !* remove default arrow on ie10 and ie11 *!*/
  /*}*/

  /* target Internet Explorer 9 to undo the custom arrow */
  @media screen and (min-width: 0\0
  ) {
    /*select {*/
    /*background:none\9;*/
    /*padding: 5px\9;*/
    /*}*/
  }
</style>
<style scoped>
  @media (max-width: 990px) {
    .list-item-menu .item-menu.mode-view-list {
      width: calc(100% - 12px) !important;
      display: flex;
      flex-direction: row;
      padding-bottom: 0;

    }

  }

  .list-item-menu .item-menu.mode-view-list {
    width: calc(100% - 12px);
    padding-bottom: 0;

  }

  .list-item-menu .item-menu.mode-view-list .menu-image {
    height: 100%;
    min-height: 160px;
  }

  .list-item-menu .item-menu.mode-view-list {
    height: 30px;
    width: 95%;
    background: hsla(0, 0%, 100%, .9);
    position: absolute;
    top: 30%;
    left: 0;
    text-align: center;
    border: 2px solid hsla(0, 0%, 100%, .9);
    border-radius: 25px;
  }
  .ribbona {
    position: absolute;
    left: 9px; top: 0px;
    z-index: 1;
    overflow: hidden;
    width: 75px; height: 75px;
    text-align: right;
  }

  @media (max-width: 786px) {
    .ribbona {
      left: 5px;
    }
  }
  .ribbona span {
    font-size: 12px;
    color: #231F20;
    text-align: center;
    line-height: 20px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    width: 100px;
    display: block;
    background: #79a70a;
    background: linear-gradient(#fff,#fafafa);
    box-shadow: 0 3px 10px -5px #000;
    position: absolute;
    top: 19px;
    left: -21px;
  }
  .ribbona span::before {
    content: "";
    position: absolute;
    left: 0;
    top: 100%;
    z-index: -1;
    border-color: hsla(207,8%,51%,.2) transparent transparent hsla(207,8%,51%,.2);
    border-style: solid;
    border-width: 2px;
  }
  .ribbona span::after {
    content: "";
    position: absolute;
    right: 0;
    top: 100%;
    z-index: -1;
    border-color: hsla(207,8%,51%,.2) hsla(207,8%,51%,.2) transparent transparent;
    border-style: solid;
    border-width: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/menu/ItemOneTap.vue